/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Avatar from '@base/Avatar/Avatar';
import P1 from '@base/P1/P1';
import H4 from '@base/H4/H4';
import { getImage } from '@utils/imageHelper';
import useWindowSize from '@hooks/useWindowSize';
import { Spacings, Fonts } from '@styles/index';
import SubHeader from './SubHeader';

const BannerWrapper = styled.div`
  background-color: var(--color-base-1);
  grid-column: span 18;
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: 0px ${Spacings.SPACING_4B} ${Spacings.SPACING_8B}
    var(--color-shadow);
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_12B};
  background-image: url('${getImage('feed_banner_bg.svg')}');
  background-repeat: no-repeat;
  background-position: left bottom;
  display: flex;
  @media only screen and (max-width: 47.95em) {
    width: 100%;
    padding: 16px;
    flex-wrap: wrap;
    background-position: top 20px left 5px;
    background-size: 50px 50px;
    margin-bottom: 32px;
  }
`;

const FeedImage = styled(Avatar)`
  cursor: default;
  background-color: transparent;
  grid-row: span 2;
`;

const FeedTitle = styled(P1)`
  padding-left: ${Spacings.SPACING_4B};
  @media only screen and (max-width: 47.95em) {
    font-size: 12px;
  }
`;

const FeedContent = styled(H4)`
  font-style: ${Fonts.REGULAR};
  font-weight: ${Fonts.SEMIBOLD};
  line-height: 25px;
  padding-left: ${Spacings.SPACING_4B};
  @media only screen and (max-width: 47.95em) {
    font-size: 14px;
    line-height: 150%;
  }
`;

const Container = styled.div`
  display: flex;
  flex: 1;
`;

const FeedContainer = styled.div``;

const FeedBanner = ({ className, imageProps, title, content, feedButton }) => {
  const imageWidth = imageProps ? imageProps.size || imageProps.width : '1fr';
  const { isMobile } = useWindowSize();

  return (
    <>
      <BannerWrapper className={className} $imgWidth={imageWidth}>
        <Container>
          <FeedImage {...imageProps} size={isMobile ? '40px' : '48px'} />
          <FeedContainer>
            <FeedTitle color="var(--color-text-secondary)">{title}</FeedTitle>
            <FeedContent color="var(--color-text-primary)" as="h3">
              {content}
            </FeedContent>
          </FeedContainer>
        </Container>
        {feedButton}
      </BannerWrapper>
      {isMobile && <SubHeader>{feedButton}</SubHeader>}
    </>
  );
};

FeedBanner.propTypes = {
  className: PropTypes.string,
  imageProps: PropTypes.objectOf(PropTypes.any).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  feedButton: PropTypes.objectOf(PropTypes.any).isRequired
};

FeedBanner.defaultProps = {
  className: ''
};

export default FeedBanner;
